import React, { useState } from 'react';
import { RenewalPrices } from '../models/superbit-api-models'
import '../assets/css/_new-lead-popup.css'
import "react-datepicker/dist/react-datepicker.css";
import { Select, TreeSelect } from 'antd';
import { RenewalsModel } from '../models/RenewalsModel'

type Props = {
    id: string | null;
    ClosePopup: any;

};
type State = {
    id: string | undefined;
    priceCasco: number | undefined;
    priceCompulsory: number | undefined;
};



class RenewalUpdatePrice extends React.Component<Props> {

    state: State = {
        id: undefined,
        priceCasco: undefined,
        priceCompulsory: undefined
    };


    constructor(props: any) {
        super(props);

        this.setState({ id: this.props.id });

    }
    componentDidMount() {

    }

    closePopup = (status?: string) => {
        this.props.ClosePopup(status);

    }

    savePrice = async () => {

        const data = new RenewalPrices();
        data.id = this.props.id==null?undefined:this.props.id;
        data.priceCasco = this.state.priceCasco !== undefined ? Number(this.state.priceCasco) : undefined;
data.priceCompulsory = this.state.priceCompulsory !== undefined ? Number(this.state.priceCompulsory) : undefined;
        await new RenewalsModel().renewalSetManualPrices(data);
    }


    render() {
        return (<>
            <div className="popup-wrapper">
                <section className="popup-window new-lead rtl">
                    <div className="close-icon pointer" onClick={(e: any) => this.closePopup()}></div>
                    <div className="popup-content">
                        <div className="popup-header">
                            <div className="popup-title"> עדכון מחיר חידוש
                            </div>
                            
                        </div>
                        <div className="popup-body">
                            <div className="tab-contents">
                                <div className="tab-content tab-content-1 selected">
                                    <div className="parameter-row">
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    מחיר קסקו                                                </div>
                                                <div className="value">
                                                    <input type="number" onChange={(e: any) => this.setState({ priceCasco: e.target.value })} value={this.state.priceCasco} />
                                                </div>
                                                {/* <div className='error-message'>
                                                    *{this.state.errors.requiredField}
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="parameter-item">
                                            <div className="field">
                                                <div className="title">
                                                    מחיר חובה
                                                </div>
                                                <div className="value">
                                                    <input type="number" onChange={(e: any) => this.setState({ priceCompulsory: e.target.value })} value={this.state.priceCompulsory} />
                                                </div>
                                                {/* <div className='error-message'>
                                                    *{this.state.errors.requiredField}
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="popup-footer">
                            <button className="button white blue-border" onClick={(e: any) => this.closePopup()}>
                                ביטול
                            </button>
                            <button className="button blue" onClick={(e: any) => this.savePrice()}  >
                                שמירה
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </>



        );
    }
}



export default (RenewalUpdatePrice);